// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".request-group-access-modal {\n  --height: auto;\n  --min-height: 260px;\n  --width: 80vw;\n  --max-width: 500px;\n}\n\n.request-group-access-modal ion-content {\n  text-align: center;\n  --padding-top: 4%;\n  --padding-start: 4%;\n  --padding-end: 4%;\n}\n\n.access-request-title {\n  margin-bottom: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
